import { Suspense } from 'react';
import Container from '@/components/Container';
import { LoadingContainer } from './components/loading-container';
import { Header } from './components/header';
import { HeaderLoading } from './components/header/loading';
import { MainFilters } from './components/main-filters';
import { CohortsFilter } from './components/cohorts-filter';
import Divider from '@/components/Divider';
import { MissionTraitAnalysis } from './components/mission-trait-analysis';
import { MissionTraitAnalysisLoading } from './components/mission-trait-analysis/loading';
import { CohortsFilterLoading } from './components/cohorts-filter/loading';
import { CompassExercisesOverTimeLoading } from './components/compass-exercises-over-time/loading';
import { CompassExercisesOverTime } from './components/compass-exercises-over-time';
import { CohortSummary } from './components/cohort-summary';
import { CohortSummaryLoading } from './components/cohort-summary/loading';
import { MissionSummaryLoading } from './components/mission-summary/loading';
import { MissionSummaryComponent } from './components/mission-summary';
import DialogComponent from './components/dialog';
import { useRoot } from './hooks/useRoot';
import { DesktopPreferedBox } from './components/desktop-prefered';
import { AdminTabs, AdminTabsEnum } from '@/components/AdminTabs';

export const ReportingTools = () => {
  const { page } = useRoot();

  return (
    <Container className="!mt-sh-60">
      <div className=" col-span-12">
        <AdminTabs activeTab={AdminTabsEnum.ReportingTools} />
        <h1 className=" font-cadiz text-sh-28-64 font-bold">{page?.title}</h1>
        <DesktopPreferedBox />
        <div className="mb-sh-30">
          <MainFilters />
        </div>
        <div className="mb-sh-30">
          <Suspense fallback={<HeaderLoading />}>
            <Header />
          </Suspense>
        </div>

        <Divider className="hidden md:block" />

        <Suspense fallback={<CohortsFilterLoading />}>
          <CohortsFilter />
        </Suspense>

        <div className="mt-sh-60 grid grid-cols-1 gap-[100px] lg:grid-cols-2 lg:gap-[45px]">
          <Suspense fallback={<MissionTraitAnalysisLoading />}>
            <MissionTraitAnalysis />
          </Suspense>
          <Suspense fallback={<CompassExercisesOverTimeLoading />}>
            <CompassExercisesOverTime />
          </Suspense>
        </div>

        <Suspense fallback={<CohortSummaryLoading />}>
          <div className="mt-[150px]">
            <CohortSummary />
          </div>
        </Suspense>

        <Suspense fallback={<MissionSummaryLoading />}>
          <div className="mt-sh-30">
            <MissionSummaryComponent />
          </div>
        </Suspense>
      </div>

      <DialogComponent />
    </Container>
  );
};

export const ReportingToolsScreen = () => {
  return (
    <Suspense fallback={<LoadingContainer title="Loading reporting tools..." />}>
      <ReportingTools />
    </Suspense>
  );
};
